import {
  RELATION__ENGAGEMENTS_STARRED
} from '../../../dictionaries/Relations.dic';
import {
  NOT
} from '../../../lib/Boolean.lib';
import Core from '../../../lib/Core';
import Engagement from '../../../lib/Engagement';
import globalErrorHandler from '../../../lib/Error/globalErrorHandler.fun';
import useState from '../../../lib/hooks/useState.hook';
import {
  mapEngagement
} from '../../../lib/models/engagement';
import {
  Obj
} from '../../../lib/Object.lib';
import {
  COLLECTION__ENGAGEMENTS,
  readLoopbackRecord
} from '../../../lib/services/BE/loopback.api';
import Icon from '../../Layout/Wrappers/Icon';
import Menu from '../../Layout/Wrappers/Menu';
import Once from '../../Layout/Wrappers/Once';
import Typography from '../../Layout/Wrappers/Typography';

export default function ActionStarEngagement({
  acl = true,
  engagementId = '',
}) {
  const [state, updateState] = useState();
  if (NOT(acl) || NOT(engagementId)) { return null; }

  const OBJ__ENGAGEMENT = Obj(state.engagement);

  const fetchEngagement = async () => {
    try {
      updateState({
        engagement: Obj(
          await readLoopbackRecord({
            collection: COLLECTION__ENGAGEMENTS,
            where: { id: engagementId },
            fields: ['id'],
            include: {
              relation: RELATION__ENGAGEMENTS_STARRED,
              scope: {
                where: { accountId: Core.getUserId() },
                limit: 1
              },
            },
            limit: 1,
            mapper: mapEngagement
          })
        )
      });
    }
    catch (error) {
      globalErrorHandler(error);
    }
  }
  return (
    <Menu.Item
      onClick={async (event) => {
        event.stopPropagation();
        try {
          const response = await Engagement.updateStarred(
            OBJ__ENGAGEMENT.id,
            OBJ__ENGAGEMENT.starredId,
            !OBJ__ENGAGEMENT.starred
          );
          OBJ__ENGAGEMENT.starred = response.starred;
          updateState({
            engagement: OBJ__ENGAGEMENT
          });
        }
        catch (error) {
          globalErrorHandler(error);
        }
      }}
      divider
    >
      <Once
        promise={fetchEngagement}
        render={false}
      />
      <Typography mr>
        Star engagement
      </Typography>
      <Icon
        icon={OBJ__ENGAGEMENT.starred ? 'star' : 'star_border'}
        className='c-gray'
      />
    </Menu.Item>
  );
}

